import { render, staticRenderFns } from "./ExitRegister.vue?vue&type=template&id=382d1d04&scoped=true"
import script from "./ExitRegister.vue?vue&type=script&lang=js"
export * from "./ExitRegister.vue?vue&type=script&lang=js"
import style0 from "./ExitRegister.vue?vue&type=style&index=0&id=382d1d04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382d1d04",
  null
  
)

export default component.exports